import { useEffect } from "react";
import "./Home.css";

export default function Home() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.tiktok.com/embed.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script); // cleanup to prevent duplicates
        };
    }, []);

    return (
        <div className="home-container">
            <div className="container">
                <div className="video-container">
                    {/* TikTok embeds here */}
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7597088645975149854" data-video-id="7597088645975149854">
                        <section>Loading TikTok...</section>
                    </blockquote>
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7595250801161882911" data-video-id="7595250801161882911">
                        <section >Loading TikTok...</section>
                    </blockquote>
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7577430398989339935" data-video-id="7577430398989339935">
                        <section>Loading TikTok...</section>
                    </blockquote>
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7575200819427937567" data-video-id="7575200819427937567">
                        <section>Loading TikTok...</section>
                    </blockquote>
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7545208888262495519" data-video-id="7545208888262495519">
                        <section>Loading TikTok...</section>
                    </blockquote>
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7530283407562132767" data-video-id="74287453719893640106">
                        <section>Loading TikTok...</section>
                    </blockquote>
                    <blockquote className="tiktok-embed" cite="https://www.tiktok.com/@marcthecs/video/7530283407562132767" data-video-id="7530283407562132767">
                        <section>Loading TikTok...</section>
                    </blockquote>
                    {/* Add more blockquotes as needed */}
                </div>
            </div>
        </div>
    );
}